// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomerTransactionsModal_root__1XPY-"};